import React from "react";

/**
 * ตัวหมุนรอสำหรับหน้า redirect โดยเฉพาะ
 *
 * ตั้งใจไม่ใช้ <BigCLoading /> ที่เป็น Lottie เพราะ lottie-react พร้อมไฟล์อนิเมชัน
 * กินพื้นที่ราว 95 kB (gzip) และในโค้ดเดิม import ไว้เฉย ๆ โดยไม่ได้ใช้ จึงถูก
 * tree-shake ทิ้งไปทั้งหมด ถ้าหน้า redirect เรียกใช้จริง bundle หลักจะโตขึ้น 95 kB
 * ซึ่งทุก route เดิมต้องดาวน์โหลดตามไปด้วยก่อนจะ redirect ได้ — ช้าลงทั้งระบบ
 *
 * ตัวนี้เป็น CSS ล้วน ไม่มี dependency จึงแทบไม่กินพื้นที่
 */
const RedirectSpinner = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <style>{`
      @keyframes bigc-spin { to { transform: rotate(360deg); } }
      @media (prefers-reduced-motion: reduce) {
        .bigc-redirect-spinner { animation-duration: 3s; }
      }
    `}</style>
    <div
      className="bigc-redirect-spinner"
      role="status"
      aria-label="กำลังพาไปยังปลายทาง"
      style={{
        width: 34,
        height: 34,
        borderRadius: "50%",
        border: "3px solid #e3e9d6",
        borderTopColor: "#93d701",
        animation: "bigc-spin .8s linear infinite",
      }}
    />
  </div>
);

export default RedirectSpinner;
